<template>
  <div class="history-record-container">
    <!-- 添加水印 -->
    <Watermark />
    
    <!-- 标题区域 -->
    <div class="page-header">
      <h2>历史记录</h2>
    </div>

    <!-- 表格区域 -->
    <div class="table-section">
      <el-table
        v-loading="loading"
        :data="recordList"
        border
        style="width: 100%"
        :header-cell-style="{ backgroundColor: '#f5f5f5', fontWeight: 'bold' }">
        <!-- 序号列 -->
        <el-table-column
          type="index"
          label="序号"
          width="80"
          align="center">
        </el-table-column>
        
        <!-- 名称列 -->
        <el-table-column
          prop="name"
          label="名称"
          min-width="150">
        </el-table-column>
        
        <!-- 英文名列 -->
        <el-table-column
          prop="englishName"
          label="英文名"
          min-width="150">
        </el-table-column>
        
        <!-- 创建时间列 -->
        <el-table-column
          prop="createTime"
          label="创建时间"
          min-width="180">
        </el-table-column>
        <el-table-column
          prop="contractNo"
          label="合同编号"
          min-width="180">
        </el-table-column>
        <el-table-column
          prop="createName"
          label="创建人"
          min-width="180">
        </el-table-column>
        <!-- 进度列 -->
        <el-table-column
          label="进度"
          min-width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.progress === 100">已完成</span>
            <span v-else>{{ scope.row.progress }}%</span>
          </template>
        </el-table-column>
        <!-- 状态 -->
        <el-table-column
          prop="progressDesc"
          label="状态"
          min-width="100">
        </el-table-column>
        <!-- 操作列 -->
        <el-table-column
          label="操作"
          min-width="200"
          align="center">
          <template slot-scope="scope">
            <div class="button-group">
              <el-button
                size="mini"
                type="primary"
                style="background-color: #5B23E8; border-color: #5B23E8; border-radius: 25px;"
                @click="viewStandardDoc(scope.row)">查看标准文档</el-button>
              <el-button
                size="mini"
                type="primary"
                style="background-color: #216FD7; border-color: #216FD7; border-radius: 25px;"
                @click="viewCompileInstructions(scope.row)">查看编制说明</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页区域 -->
    <div class="pagination-section">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pagination.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total">
      </el-pagination>
    </div>

    <!-- 标准文档查看对话框 -->
    <el-dialog 
      title="标准文档" 
      :visible.sync="standardDocVisible" 
      width="70%" 
      :close-on-click-modal="false">
      <div class="html-content" v-html="currentHtmlContent"></div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editStandardDocOnline" type="success" :disabled="!currentRow.htmlContentDoc" :loading="uploading">在线编辑</el-button>
        <el-button @click="downloadStandardDoc" type="primary" :disabled="!currentRow.htmlContentDoc">下载文档</el-button>
        <el-button @click="standardDocVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 编制说明查看对话框 -->
    <el-dialog 
      title="编制说明" 
      :visible.sync="compileInstructionsVisible" 
      width="70%" 
      :close-on-click-modal="false">
      <div class="html-content" v-html="currentHtmlBzsm"></div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editCompileInstructionsOnline" type="success" :disabled="!currentRow.htmlBzsmDoc" :loading="uploading">在线编辑</el-button>
        <el-button @click="downloadCompileInstructions" type="primary" :disabled="!currentRow.htmlBzsmDoc">下载文档</el-button>
        <el-button @click="compileInstructionsVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { get } from '@/utils/fetch';
import Watermark from '@/components/Watermark.vue';
import axios from 'axios';

export default {
  name: 'HistoryRecord',
  components: {
    Watermark
  },
  data() {
    return {
      // 记录列表
      recordList: [],
      // 加载状态
      loading: false,
      // 分页参数
      pagination: {
        page: 1,
        size: 10,
        total: 0
      },
      // 对话框显示状态
      standardDocVisible: false,
      compileInstructionsVisible: false,
      // 当前选中的内容
      currentHtmlContent: '',
      currentHtmlBzsm: '',
      // 当前选中的行数据
      currentRow: {},
      // 上传状态
      uploading: false
    };
  },
  created() {
    this.fetchRecordList();
  },
  methods: {
    // 获取历史记录列表
    fetchRecordList() {
      this.loading = true;
      const params = {
        page: this.pagination.page,
        pageSize: this.pagination.size
      };
      
      get('/api/aibz/content/list', params)
        .then(response => {
          this.loading = false;
          
          if (response && response.code === 0) {
            this.recordList = response.data || [];
            this.pagination.total = response.total || 0;
          } else {
            this.$message.error(response.message || '获取历史记录失败');
          }
        })
        .catch(error => {
          this.loading = false;
          console.error('获取历史记录失败:', error);
          this.$message.error('网络异常，请稍后重试');
        });
    },
    
    // 分页大小变化
    handleSizeChange(size) {
      this.pagination.size = size;
      this.fetchRecordList();
    },
    
    // 页码变化
    handleCurrentChange(page) {
      this.pagination.page = page;
      this.fetchRecordList();
    },
    
    // 查看标准文档
    viewStandardDoc(row) {
      this.currentRow = row;
      this.currentHtmlContent = row.htmlContent || '<p>暂无内容</p>';
      this.standardDocVisible = true;
    },
    
    // 查看编制说明
    viewCompileInstructions(row) {
      this.currentRow = row;
      this.currentHtmlBzsm = row.htmlBzsm || '<p>暂无内容</p>';
      this.compileInstructionsVisible = true;
    },
    
    // 下载标准文档
    downloadStandardDoc() {
      if (this.currentRow.htmlContentDoc) {
        window.open(this.currentRow.htmlContentDoc, '_blank');
      } else {
        this.$message.warning('没有可下载的文档');
      }
    },
    
    // 下载编制说明
    downloadCompileInstructions() {
      if (this.currentRow.htmlBzsmDoc) {
        window.open(this.currentRow.htmlBzsmDoc, '_blank');
      } else {
        this.$message.warning('没有可下载的文档');
      }
    },
    
    // 在线编辑标准文档
    async editStandardDocOnline() {
      if (!this.currentRow.htmlContentDoc) {
        this.$message.warning('没有可编辑的文档');
        return;
      }
      
      try {
        this.uploading = true;
        
        // 显示加载提示
        this.$message({
          message: '准备文档中，请稍候...',
          type: 'info',
          duration: 0
        });
        
        // 获取文档ID
        const fileName = this.currentRow.name || '标准文档.docx';
        const docId = this.extractDocId(this.currentRow.htmlContentDoc);
        
        if (!docId) {
          throw new Error('无法获取文档ID');
        }
        
        // 1. 使用axios获取文件流
        const response = await axios.get(`/api/aibz/content/doc`, {
          params: { id: docId },
          responseType: 'blob',
          // 确保凭证被发送
          withCredentials: true
        });
        
        if (!response || !response.data) {
          throw new Error('文档下载失败');
        }
        
        const blob = response.data;
        
        // 2. 将文件上传到接口
        const formData = new FormData();
        formData.append('file', blob, `${fileName}.docx`);
        
        // 使用axios上传文件
        const uploadResponse = await axios.post('http://140.143.169.8:7777/api/file/upload', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        
        if (!uploadResponse || !uploadResponse.data) {
          throw new Error('文件上传失败');
        }
        
        const uploadResult = uploadResponse.data;
        
        // 关闭提示
        this.$message.closeAll();
        
        if (!uploadResult.fileId) {
          throw new Error('获取文件ID失败');
        }
        
        // 3. 使用fileId和文件名打开新标签页
        const routeUrl = `/#/standard-editor/${uploadResult.fileId}?fileName=${encodeURIComponent(fileName)}`;
        window.open(routeUrl, '_blank');
        
        // 关闭当前对话框
        this.standardDocVisible = false;
        
        this.$message.success('文档已准备好，正在打开编辑器');
      } catch (error) {
        console.error('在线编辑失败:', error);
        this.$message.error(`在线编辑失败: ${error.message}`);
      } finally {
        this.uploading = false;
        this.$message.closeAll();
      }
    },
    
    // 在线编辑编制说明
    async editCompileInstructionsOnline() {
      if (!this.currentRow.htmlBzsmDoc) {
        this.$message.warning('没有可编辑的文档');
        return;
      }
      
      try {
        this.uploading = true;
        
        // 显示加载提示
        this.$message({
          message: '准备文档中，请稍候...',
          type: 'info',
          duration: 0
        });
        
        // 获取文档ID
        const fileName = `${this.currentRow.name || '标准文档'}_编制说明.docx`;
        const docId = this.extractDocId(this.currentRow.htmlBzsmDoc);
        
        if (!docId) {
          throw new Error('无法获取文档ID');
        }
        
        // 1. 使用axios获取文件流
        const response = await axios.get(`/api/aibz/bzsm/doc`, {
          params: { id: docId },
          responseType: 'blob',
          // 确保凭证被发送
          withCredentials: true
        });
        
        if (!response || !response.data) {
          throw new Error('文档下载失败');
        }
        
        const blob = response.data;
        
        // 2. 将文件上传到接口
        const formData = new FormData();
        formData.append('file', blob, `${fileName}.docx`);
        
        // 使用axios上传文件
        const uploadResponse = await axios.post('http://140.143.169.8:7777/api/file/upload', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        
        if (!uploadResponse || !uploadResponse.data) {
          throw new Error('文件上传失败');
        }
        
        const uploadResult = uploadResponse.data;
        
        // 关闭提示
        this.$message.closeAll();
        
        if (!uploadResult.fileId) {
          throw new Error('获取文件ID失败');
        }
        
        // 3. 使用fileId和文件名打开新标签页
        const routeUrl = `/#/standard-editor/${uploadResult.fileId}?fileName=${encodeURIComponent(fileName)}`;
        window.open(routeUrl, '_blank');
        
        // 关闭当前对话框
        this.compileInstructionsVisible = false;
        
        this.$message.success('文档已准备好，正在打开编辑器');
      } catch (error) {
        console.error('在线编辑失败:', error);
        this.$message.error(`在线编辑失败: ${error.message}`);
      } finally {
        this.uploading = false;
        this.$message.closeAll();
      }
    },
    
    // 从URL中提取文档ID
    extractDocId(url) {
      if (!url) return null;
      
      try {
        // 尝试从URL中提取id参数
        const urlObj = new URL(url);
        return urlObj.searchParams.get('id');
      } catch (error) {
        console.error('URL解析失败:', url, error);
        
        // 备用方案：正则表达式提取
        const idMatch = url.match(/[?&]id=([^&]+)/);
        return idMatch ? idMatch[1] : null;
      }
    }
  }
};
</script>

<style scoped>
.history-record-container {
  padding: 20px;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.page-header {
  margin-bottom: 20px;
}

.page-header h2 {
  margin: 0;
  font-size: 22px;
  color: #303133;
}

.table-section {
  flex: 1;
  margin-bottom: 20px;
}

.pagination-section {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.button-group {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.html-content {
  max-height: 60vh;
  overflow-y: auto;
  padding: 10px;
  background-color: #fafafa;
  border-radius: 4px;
}

/* 解决弹出框内可能存在的样式问题 */
:deep(.html-content) {
  line-height: 1.5;
  font-size: 14px;
}

:deep(.html-content) table {
  border-collapse: collapse;
  width: 100%;
}

:deep(.html-content) th,
:deep(.html-content) td {
  border: 1px solid #dcdfe6;
  padding: 8px;
}

.el-button+.el-button, .el-checkbox.is-bordered+.el-checkbox.is-bordered {
  margin-left: 0;
}
.el-dialog__wrapper .el-button+.el-button, .el-checkbox.is-bordered+.el-checkbox.is-bordered {
  margin-left: 10px;
}
</style> 